export default __webpack_public_path__ + "static/media/00.8fc2baaa.jpg";